import { advancedFlowSchema_ } from "@redotech/redo-flows-common/advanced-flow-db-parser";
import { SchemaType } from "@redotech/redo-flows-common/schemas/schemas";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

/**
 * Save a draft revision of a processing flow (Compensation / Restocking).
 *
 * If `flowRevisionId` is provided and an unpublished revision with that id
 * exists, the steps for each phase are replaced in place — successive saves
 * of the same draft don't accumulate new docs.
 *
 * Otherwise a fresh `flowRevisionId` is minted and one new draft AdvancedFlow
 * doc is created per phase, copying metadata (name, enabled, category, etc.)
 * from the most recent doc in the phase's `versionGroupId`.
 *
 * Returns the resulting `flowRevisionId` so the editor can hold onto it and
 * pass it back on the next save, and `flowIds` for downstream operations
 * (e.g. a follow-up Publish).
 */
export const saveProcessingFlowDraft = {
  name: "saveProcessingFlowDraft" as const,
  input: z.object({
    schemaType: createEnum(SchemaType),
    flowRevisionId: z.string().optional(),
    phases: z
      .array(
        z.object({
          versionGroupId: z.string(),
          steps: advancedFlowSchema_.shape.steps,
        }),
      )
      .min(1),
  }),
  output: z.object({
    flowRevisionId: z.string(),
    flowIds: z.array(z.string()),
  }),
};
